import React from 'react';
import { useSelector } from 'react-redux';
import {
  isImpersonatingSelector,
  currentAccountConsumerFullNameSelector
} from 'store/account/selectors';
import { StyledMuiBox, StyledMuiTypography } from './styled';

const AccountProxyIndicator = () => {
  const isImpersonating = useSelector(isImpersonatingSelector);
  const name = useSelector(currentAccountConsumerFullNameSelector);

  if (!isImpersonating) return null;

  return (
    <StyledMuiBox>
      <StyledMuiTypography data-testid="viewing-as">Viewing as {name}</StyledMuiTypography>
    </StyledMuiBox>
  );
};

export default AccountProxyIndicator;
